const accessProject = {


    PROJECT_LIST: {
        path: '/project-list'
    },

    PROJECT_DETAILS: {
        path: '/project-details'
    },

    ADD_PROJECT: {
        path: '/create-project'
    },

    UPDATE_PROJECT: {
        path: '/edit-project'
    },


}

export default accessProject;